export default {"src":"/_next/static/media/stressMotivationMobile.bce66448.svg","height":233,"width":272,"blurWidth":0,"blurHeight":0};